module.exports = __webpack_public_path__ + "img/Guirlande_papier.65bbe94.jpg";